import { type DossierOpenSearchJsonldOpensearchDossierStatutRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export const DOSSIER_STATUS_DRAFT = 1;
export const DOSSIER_STATUS_IN_PROGRESS = 3;
export const DOSSIER_STATUS_DONE = 6;
export const DOSSIER_STATUS_ARCHIVED = 34;
export const DOSSIER_STATUS_TRANSMITTED_CANCELLED = 35;
export const DOSSIER_STATUS_DRAFT_CANCELLED = 47;
export const DOSSIER_STATUS_AWAITING = 48;
export const DOSSIER_STATUS_SUSPENDED = 49;
export const DOSSIER_STATUS_INCOMPLETE = 50;
export const DOSSIER_STATUS_TRANSMIT = 51;
export const DOSSIER_STATUS_REJECTED_S2 = 52;
export const DOSSIER_STATUS_REGULS = 53;
export const DOSSIER_STATUS_TO_CHECK = 61;
export const DOSSIER_STATUS_READY_TO_TRANSMIT = 62;
export const DOSSIER_STATUS_VALIDATED = 63;
export const DOSSIER_STATUS_REJECTED_S4 = 64;

export const getDossierStatus = (): DossierOpenSearchJsonldOpensearchDossierStatutRead[] => [
    {
        id: DOSSIER_STATUS_AWAITING,
        libelle: 'En attente',
        childsCount: 0,
        stepLabel: 'Dossier en préparation',
    },
    {
        id: DOSSIER_STATUS_IN_PROGRESS,
        libelle: 'En cours de traitement',
        childsCount: 0,
        stepLabel: 'Dossier en préparation',
    },
    {
        id: DOSSIER_STATUS_INCOMPLETE,
        libelle: 'Dossier incomplet',
        childsCount: 0,
        stepLabel: 'Dossier en préparation',
    },
    {
        id: DOSSIER_STATUS_TO_CHECK,
        libelle: 'Dossier à contrôler',
        childsCount: 0,
        stepLabel: 'Dossier en préparation',
    },
    {
        id: DOSSIER_STATUS_TRANSMIT,
        libelle: 'Déposé',
        childsCount: 0,
        stepLabel: 'Transmis pour validation',
    },
    {
        id: DOSSIER_STATUS_TRANSMITTED_CANCELLED,
        libelle: 'Annulé',
        childsCount: 0,
        stepLabel: 'Transmis à mon formaliste',
    },
    {
        id: DOSSIER_STATUS_ARCHIVED,
        libelle: 'Archivé',
        childsCount: 0,
        stepLabel: 'Dossier finalisé',
    },
    {
        id: DOSSIER_STATUS_DONE,
        libelle: 'Finalisé',
        childsCount: 0,
        stepLabel: 'Dossier finalisé',
    },
    {
        id: DOSSIER_STATUS_VALIDATED,
        libelle: 'A valider',
        childsCount: 0,
        stepLabel: 'Transmis pour validation',
    },
];
